// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_fx-0";
export var fileCarousel = "_fx-2";
export var removeFileButton = "_fx-1";